import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Select from 'lib/forms/select'

const Question = ({ errors, question, questionTypes, onChange }) => (
  <div className={`form-element large ${errors.question ? 'has-errors' : ''}`}>
    <label className='block'>{I18n.t('pages.contact.question')}</label>
    <Select value={question} options={questionTypes} onValueChange={onChange} />
    {errors && errors.question ? <div className='simple-error'>{errors.question}</div> : null}
  </div>
)

export default Question

Question.propTypes = {
  errors: PropTypes.object,
  onChange: PropTypes.func,
  question: PropTypes.string,
  questionTypes: PropTypes.array
}
